import { motion } from 'framer-motion';

const risks = [
  { name: 'La ley cambia o se retrasa', impact: 4, probability: 3, mitigation: 'Los arraigos, la nacionalidad y los visados no dependen de la regularizacion. Si se retrasa, seguimos facturando.', color: '#f97316' },
  { name: 'Competidores copian el modelo', impact: 3, probability: 4, mitigation: '2 anos de desarrollo, 112 tablas, 5 agentes IA. Copiarlo lleva 18+ meses. Para entonces estamos en Fase 2.', color: '#f97316' },
  { name: 'La IA comete errores legales', impact: 4, probability: 1, mitigation: 'Pili no decide — recomienda. Score minimo 8.0/10. Siempre hay un abogado humano revisando.', color: '#3b82f6' },
  { name: 'Los abogados se dan de baja', impact: 4, probability: 3, mitigation: 'El abogado gana 12-18x lo que paga. Sin permanencia, pero el ROI lo retiene. El CRM crea dependencia.', color: '#f97316' },
  { name: 'Regulacion financiera (licencias)', impact: 5, probability: 3, mitigation: 'Arrancamos bajo licencia de un partner (Unnax). Solicitamos las nuestras en paralelo. No paramos.', color: '#ef4444' },
  { name: 'No hay suficientes abogados por zona', impact: 3, probability: 2, mitigation: 'La exclusividad es una feature: menos abogados = mas leads para cada uno = mas satisfaccion.', color: '#10b981' },
  { name: 'El abogado se salta a Migro', impact: 3, probability: 3, mitigation: 'El abogado no puede generar 20 leads/semana por su cuenta. El volumen constante es nuestro lock-in.', color: '#f97316' },
  { name: 'Blockchain es cara o lenta', impact: 2, probability: 1, mitigation: 'Base L2 cobra 0.01 USD por transaccion. Es practicamente gratis. Y el usuario nunca toca blockchain.', color: '#10b981' },
];

export function RiskMatrix() {
  return (
    <section id="risks" className="py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="mb-10 text-center"
        >
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-emerald-400">
            Riesgos
          </span>
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">
            Conocemos los riesgos.{' '}
            <span className="bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent">
              Ya tenemos respuesta para cada uno.
            </span>
          </h2>
        </motion.div>

        <div className="grid gap-6 lg:grid-cols-2">
          {/* Matrix visual */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="rounded-2xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-md"
          >
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-400">Matriz Impacto x Probabilidad</h3>
            <div className="relative aspect-square max-w-sm mx-auto">
              <div className="absolute inset-0 grid grid-cols-5 grid-rows-5">
                {Array.from({ length: 25 }).map((_, i) => {
                  const row = Math.floor(i / 5);
                  const col = i % 5;
                  const severity = row + col;
                  const bg = severity >= 6 ? 'bg-red-500/10' : severity >= 4 ? 'bg-orange-500/10' : severity >= 2 ? 'bg-yellow-500/5' : 'bg-emerald-500/5';
                  return <div key={i} className={`border border-white/5 ${bg}`} />;
                })}
              </div>
              <div className="absolute -left-8 top-1/2 -translate-y-1/2 -rotate-90 text-[10px] font-semibold uppercase tracking-wider text-slate-500">
                Impacto
              </div>
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-[10px] font-semibold uppercase tracking-wider text-slate-500">
                Probabilidad
              </div>
              {risks.map((r, i) => (
                <motion.div
                  key={i}
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.05 * i, type: 'spring' }}
                  className="absolute flex h-5 w-5 items-center justify-center rounded-full ring-2 ring-white/20"
                  style={{
                    left: `${(r.probability - 0.5) * 20}%`,
                    bottom: `${(r.impact - 0.5) * 20}%`,
                    backgroundColor: r.color,
                  }}
                  title={r.name}
                >
                  <span className="text-[8px] font-bold text-white">{i + 1}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Risk list */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="space-y-2"
          >
            {risks.map((r, i) => (
              <div key={i} className="rounded-xl border border-white/10 bg-white/[0.06] p-3.5 backdrop-blur-md">
                <div className="flex items-center gap-2">
                  <span
                    className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[9px] font-bold text-white"
                    style={{ backgroundColor: r.color }}
                  >
                    {i + 1}
                  </span>
                  <span className="text-sm font-semibold text-slate-200">{r.name}</span>
                  <span className="ml-auto text-[10px] text-slate-500">
                    I:{r.impact} P:{r.probability}
                  </span>
                </div>
                <p className="mt-1.5 pl-7 text-xs text-slate-400">{r.mitigation}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
